<template>
  <div id="grid-map-controls-sidebar-layers">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="active"
      class="items-no-padding"
    >
      <div class="h-full">
        <slot name="header"></slot>
        <vs-divider class="mb-0" color="#828282" />
        <slot name="main"></slot>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
/**
 * マップ右端に表示されるメニュー、１マップ毎にメニューを切り替えることができる。
 * @parent T.MapViewGridMain
 * @props map: Object １マップ分のインスタンスデータ
 */
export default {
  name: "O.RightMenuBase",
  props: {
    /** 右メニューの開閉状態を管理 */
    isActiveMenu: {
      type: Boolean,
      required: false,
    },
    /**
     * キー押下イベントの設定
     * { isEnable: boolean, keyCode: number }
     */
    keyDownCloseSetting: {
      type: Object,
      required: false,
      default: () => ({
        isEnable: false,
        keyCode: 0,
      }),
    },
    /** メニューを閉じる関数 */
    closeSidebar: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      active: false,
    };
  },
  watch: {
    active(newValue) {
      if (!this.keyDownCloseSetting || !this.keyDownCloseSetting.isEnable)
        return;

      if (newValue) {
        window.addEventListener("keydown", this.keyDownEvent);
      } else {
        window.removeEventListener("keydown", this.keyDownEvent);
      }
    },
    isActiveMenu(newValue) {
      this.active = newValue;
    },
  },
  methods: {
    keyDownEvent(e) {
      if (e.keyCode === this.keyDownCloseSetting.keyCode) {
        this.closeSidebar();
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#grid-map-controls-sidebar-layers {
  .vs-collapse-item--header {
    padding-left: 0;
  }

  .vs-collapse {
    padding: 0 20px 20px;
  }

  .vs-collapse-item--content {
    border-radius: 5px;
  }

  .header-label {
    color: #f2f2f2;
  }

  .icon-header {
    color: #f2f2f2;
  }

  .con-content--item {
    background-color: $aisea-blue-gray;
  }

  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
    }
  }

  .vs-collapse-item {
    border-bottom: 0;
  }

  .vs-collapse-item--icon-header {
    right: -15px;
  }
  .grid-map-menu-body {
    height: 100vh;
    .grid-map-scroll-area--customizer {
      max-height: calc(100% - 5rem);
      box-sizing: border-box;
      z-index: 10;

      &:not(.ps) {
        overflow-y: auto;
      }
    }
    /** タブのみ存在するパターン */
    .grid-map-tab-form ~ .grid-map-scroll-area--customizer {
      max-height: calc(100% - 5rem - 40px);
    }
    /** 検索フォームのみ存在するパターン */
    .grid-map-search-form ~ .grid-map-scroll-area--customizer {
      max-height: calc(100% - 5rem - 65px);
    }
    /** タブと検索フォームが存在するパターン */
    .grid-map-tab-form
      ~ .grid-map-search-form
      ~ .grid-map-scroll-area--customizer {
      max-height: calc(100% - 5rem - 40px - 65px);
    }
  }
}
</style>
